<template>
<div>
  <div v-for="(cfile, cindex) in file.completedFiles" :key="cindex">
    <div v-if="cfile.translation_original_file_id === file.id" class="field file-padded-top" :class="cindex < file.completedFiles.length-1 ? 'padded-bottom-border' : ''">
      <div class="control" style="padding-bottom:5px;">
        <div class="columns">
          <div class="column is-2">
            <div class="formfield">
              <strong>Version {{cfile.version}}</strong>
            </div>
          </div>
          <div class="column is-5">
            <div class="formfield view-file" @click="showFile(cfile)" v-html="cfile.filename"></div>
          </div>
          <div class="column is-3">
            <div class="formfield">
              <div class="uploaded-at pull-left">
                {{ formatDateTime(cfile.created_at) }}
              </div>
            </div>
          </div>
          <div class="column is-2">
            <div class="formfield" v-html="translationStatus(cfile.translation_status_id)">
            </div>
          </div>
        </div>
      </div>
      <div class="control">
        <div class="columns" style="padding-top: 1.5rem;">
          <div class="column is-2">
          </div>
          <div class="column is-10" style="border-top: 1px solid #E8EBF4;">
            {{cfile.notes}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";

export default {
  props: {
    file: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
    };
  },

  computed: {
    ...mapGetters("requests", {
      //completedFiles: "getcompletedFiles"
    }),
  },

  methods: {
    showFile(file){
      this.$emit('show-file', file);
    },

    // format datetime to 12/01/2018 at 4:00 PM
    formatDateTime(value){
      if (!value) return "Unknown";
      return (
        moment(value).format("MM/DD/YY") +
        " at " +
        moment(value).format("hh:mm A")
      );
    },

    translationStatus(value){
      switch(value){
        case 1:
          return '<span class="btn btn-static btn-approved">Approved</span>';
        case 2:
          return '<span class="btn btn-static btn-reviewing">Reviewing</span>';
        case 3:
          return '<span class="btn btn-static btn-rejected">Rejected</span>';
        default:
          return '';
      }
    },
  },

  mounted() {},

  created() {},
};
</script>

<style scoped>
.formfield{
  padding: 5px;
}

.column{
  overflow-wrap: break-word;
}

</style>
